<template>
    <transition name="fade">
        <div class="order-remark">
            <div class="remark-form">
                <Icon type="md-close" size="18" class="close-btn" @click="$emit('close')"/>
                <div class="form-title-box">
                    添加备注
                </div>
                <div class="form-content">
                    <div class="form-item">
                        <div class="form-item-label">备注图标颜色</div>
                        <div class="form-item-value">
                            <RadioGroup class="radio-group" v-model="form.color">
                                <Radio v-for="(item,index) in remark_type" :label="item.value" :key="index" class="radio-item">
                                    <img :src="item.icon" alt="" />
                                </Radio>
                            </RadioGroup>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-label">备注内容说明</div>
                        <div class="form-item-value">
                            <textarea v-model="form.memo" type="textarea" placeholder="请输入备注内容" class="input-item"/>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <div class="btn save" @click="onRemark">保存</div>
                    <div class="btn cancel" @click="$emit('close')">取消</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { shopOrderRemark } from '@/api/index';
export default{
    name:"OrderRemark",
    data(){
        return{
            remark_type:[
                {name:'绿色',value:'green',icon:require('@/assets/images/shop-manage/icon-shop-order-remark-green.png')},
                {name:'蓝色',value:'blue',icon:require('@/assets/images/shop-manage/icon-shop-order-remark-blue.png')},
                {name:'黄色',value:'yellow',icon:require('@/assets/images/shop-manage/icon-shop-order-remark-yellow.png')},
                {name:'红色',value:'red',icon:require('@/assets/images/shop-manage/icon-shop-order-remark-red.png')},
            ],
            form:{
                uuid:'',
                color:'green',
                memo:''
            }
        }
    },
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    mounted(){
        const {uuid,owner_memo,owner_flag} = this.order;
        if(!uuid){
            this.$layer.msg('订单ID不存在');
            // this.$emit("close");
            return;
        }
        this.form.color = owner_flag || '';
        this.form.memo = owner_memo || '';
        this.form.uuid = uuid;

    },
    methods:{
        async onRemark(){
            try{
                const {code,msg} = await shopOrderRemark(this.form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('备注添加成功~');
                this.$emit('on-remarked');
                this.$emit('close');
            }catch(e){
                console.log('err-remark',e);
                this.$layer.msg(e.msg);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.order-remark{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position:fixed;
    top:0;
    left:0;
    z-index:999;
    display:flex;
    align-items:center;
    justify-content:center;
    transform:none !important;
    transform-origin:unset !important;
    .remark-form{
        width:628px;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        position:relative;
        .close-btn{
            position:absolute;
            top:14px;
            right:14px;
            font-size:18px;
            cursor:pointer;
        }
        .form-title-box{
            width:100%;
            font-size:16px;
            color:#0f1115;
            font-weight:500;
            padding:18px 24px;
            border-bottom:1px solid #e0e0e0;
        }
        .form-content{
            width:100%;
            padding:28px 20px 0 24px;
            display:flex;
            flex-direction:column;
            row-gap:29px;
            .form-item{
                width:100%;
                display:flex;
                column-gap:16px;
                .form-item-label{
                    color:#666666;
                    font-size:14px;
                }
                .form-item-value{
                    flex:1;
                    display:flex;
                    align-items:center;
                    .radio-group{
                        display:flex;
                        align-items:center;
                        column-gap:24px;
                        .radio-item{
                            display:flex;
                            align-items:center;
                        }
                    }
                    img{
                        width:22px;
                        height:22px;
                    }
                    .input-item{
                        width:100% !important;
                        height:200px !important;
                        border:1px solid #e3e3e3 !important;
                        border-radius:10px !important;
                        padding:12px 16px;
                        text-align:baseline;
                        outline:none;
                    }
                }
            }
        }
        .btn-box{
            width:100%;
            display:flex;
            justify-content:flex-end;
            align-items:center;
            margin-top:16px;
            margin-bottom:26px;
            padding-right:20px;
            column-gap:8px;
            .btn{
                width:78px;
                height:32px;
                font-size:14px;
                cursor:pointer;
                border-radius:4px;
                text-align:center;
                line-height:32px;
                &.save{
                    color:#ffffff;
                    background:#ff5967;
                }
                &.cancel{
                    color:#666666;
                    border:1px solid #e3e3e3;
                }
            }
        }
    }
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff5967;
}

::v-deep .ivu-radio-inner:after{
    background-color:#ff5967;
}
</style>